import { render } from "./GlobalFilters.vue?vue&type=template&id=122d0b71&ts=true"
import script from "./GlobalFilters.vue?vue&type=script&lang=ts"
export * from "./GlobalFilters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__